// This should be consistent with PurchaseEntity.MAX_TICKET_COUNT on ApiServer.
export const MAX_BOOKING_GUEST_SIZE = 1000;
export const MIN_BOOKING_GUEST_SIZE = 1;
export const MAX_BOOKING_SIZE_TOGO_A_LA_CARTE = 1;
